(function ($) {
    var $fn = $(".comp_my_credit_points");

    if ($fn.length) {

    }
})(jQuery);